import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { TooltipNotificationComponent } from 'core/tooltip-notification/tooltip-notification.component';
import { AppMaterialModule } from 'src/app/app-material.module';
import { AccountsEmailComponent } from '../crm/accounts/accounts-list/accounts-email/accounts-email.component';
import { DeliveryEmailComponent } from '../crm/accounts/accounts-list/delivery-email/delivery-email.component';
import { SharedModule } from '../shared/shared.module';
import { InvoiceDetailsComponent } from './invoices/invoice-details/invoice-details.component';
import { InvoiceFooterComponent } from './invoices/invoice-footer/invoice-footer.component';
import { InvoiceHeaderComponent } from './invoices/invoice-header/invoice-header.component';
import { InvoiceViewComponent } from './invoices/invoice-view/invoice-view.component';
import { OrderTrackingComponent } from './invoices/order-tracking/order-tracking.component';
import { PosRoutingModule } from './pos-routing.module';
import { ConsignedWarehouseComponent } from './quotes/consigned-warehouse/consigned-warehouse.component';
import { AddProductComponent } from './quotes/add-item/add-product.component';
import { CustomToolComponent } from './quotes/custom-tool/custom-tool.component';
import { OrderCompletedComponent } from './quotes/order-completed/order-completed.component';
import { CvvModalComponent } from './quotes/payment-chase/cvv-modal/cvv-modal.component';
import { PaymentChaseComponent } from './quotes/payment-chase/payment-chase.component';
import { PaymentDetailsComponent } from './quotes/payment-details/payment-details.component';
import { ProductGridComponent } from './quotes/product-grid/product-grid.component';
import { QuoteAtpComponent } from './quotes/quote-atp/quote-atp.component';
import { QuoteDetailsComponent } from './quotes/quote-details/quote-details.component';
import { QuoteExpiredComponent } from './quotes/quote-expired/quote-expired.component';
import { QuoteListComponent } from './quotes/quote-list/quote-list.component';
import { QuoteRestoreComponent } from './quotes/quote-restore/quote-restore.component';
import { QuoteVersioningComponent } from './quotes/quote-versioning/quote-versioning.component';
import { PrintExportQuoteComponent } from './quotes/quote/print-export-quote/print-export-quote.component';
import { ToolNotesDialogComponent } from './quotes/tool-notes-dialog/tool-notes-dialog.component';
import { SimpleUploadComponent } from './simple-upload/simple-upload.component';
import { QuoteAdvancedSearchComponent } from './quotes/quote-advanced-search/quote-advanced-search.component';
import { PaymentBarclaysComponent } from './quotes/payment-barclays/payment-barclays.component';
import { BarclaysFormLegacyComponent } from './quotes/barclays-form-legacy/barclays-form-legacy.component';
import { BarclaysPaymentProcessingLegacyComponent } from
  './quotes/barclays-payment-processing-legacy/barclays-payment-processing-legacy.component';
import { PaymentBarclaysLegacyComponent } from './quotes/payment-barclays-legacy/payment-barclays-legacy.component';
import { QuoteEmailNotificationComponent } from './quotes/quote-email-notification/quote-email-notification.component';
import { AtpButtonComponent } from './quotes/product-grid/atp-button/atp-button.component';
import { GridProductSearchComponent } from './quotes/product-grid/grid-product-search/grid-product-search.component';
import { ProductImageGalleryComponent } from './quotes/product-grid/product-image-gallery/product-image-gallery.component';
import { ProductRowDetailComponent } from './quotes/product-grid/product-row-detail/product-row-detail.component';
import { LnOrderComponent } from './ln-orders/ln-order/ln-order.component';
import { LnOrderHeaderComponent } from './ln-orders/ln-order-header/ln-order-header.component';
import { LnOrderDetailsComponent } from './ln-orders/ln-order-details/ln-order-details.component';
import { QuoteComponent } from './quotes/quote/quote.component';
import { QuoteOptionsComponent } from './quotes/quote-options/quote-options.component';

@NgModule({
  declarations: [
    QuoteComponent,
    ProductGridComponent,
    QuoteDetailsComponent,
    PaymentDetailsComponent,
    QuoteOptionsComponent,
    ToolNotesDialogComponent,
    TooltipNotificationComponent,
    QuoteListComponent,
    QuoteAtpComponent,
    ConsignedWarehouseComponent,
    AddProductComponent,
    AccountsEmailComponent,
    DeliveryEmailComponent,
    SimpleUploadComponent,
    PaymentChaseComponent,
    CvvModalComponent,
    PrintExportQuoteComponent,
    QuoteVersioningComponent,
    QuoteRestoreComponent,
    QuoteExpiredComponent,
    OrderCompletedComponent,
    InvoiceDetailsComponent,
    InvoiceViewComponent,
    InvoiceHeaderComponent,
    InvoiceFooterComponent,
    CustomToolComponent,
    OrderTrackingComponent,
    QuoteAdvancedSearchComponent,
    PaymentBarclaysComponent,
    BarclaysFormLegacyComponent,
    BarclaysPaymentProcessingLegacyComponent,
    PaymentBarclaysLegacyComponent,
    QuoteEmailNotificationComponent,
    AtpButtonComponent,
    GridProductSearchComponent,
    ProductImageGalleryComponent,
    ProductRowDetailComponent,
    LnOrderComponent,
    LnOrderHeaderComponent,
    LnOrderDetailsComponent,
  ],
  imports: [
    SharedModule,
    CommonModule,
    MatPaginatorModule,
    PosRoutingModule,
    AppMaterialModule
  ],
  exports: [
    GridProductSearchComponent
  ]
})
export class PosModule { }
